import { useQuery } from "@apollo/client"
import constate from "constate"
import { useState } from "react"
import { CHANGE_PARTNERSHIP_TIER_QUERY } from "./queries"
import { ChangePartnershipTierModalItemFragment } from "__generated__/ChangePartnershipTierModalItemFragment"
import { ChangePartnershipTierQuery } from "__generated__/ChangePartnershipTierQuery"
import { ChangePartnershipTierModalPartnershipFragment } from "__generated__/ChangePartnershipTierModalPartnershipFragment"

const [ChangePartnershipTierModalProvider, useChangePartnershipTierModal] =
    constate(({ recruitingTeam }: { recruitingTeam?: string }) => {
        const [isModalOpen, setModalOpen] = useState<boolean>(false)
        const [newItem, setNewItem] = useState<
            ChangePartnershipTierModalItemFragment | undefined
        >(undefined)
        const [partnership, setPartnership] = useState<
            ChangePartnershipTierModalPartnershipFragment | undefined
        >(undefined)
        const [changeType, setChangeType] = useState<
            "upgrade" | "downgrade" | "change plan" | undefined
        >(undefined)

        const { data } = useQuery<ChangePartnershipTierQuery>(
            CHANGE_PARTNERSHIP_TIER_QUERY,
            {
                variables: { recruitingTeam },
                skip: !recruitingTeam,
            }
        )

        const showModal = (
            item: ChangePartnershipTierModalItemFragment,
            partnership: ChangePartnershipTierModalPartnershipFragment,
            change: "upgrade" | "downgrade" | "change plan"
        ) => {
            setNewItem(item)
            setPartnership(partnership)
            setChangeType(change)
            setModalOpen(true)
        }

        const hideModal = () => {
            setModalOpen(false)
            setNewItem(undefined)
            setPartnership(undefined)
            setChangeType(undefined)
        }

        return {
            isModalOpen,
            showModal,
            hideModal,
            newItem,
            partnership,
            changeType,
            recruitingTeam,
            shouldCollectPayment:
                data && !data.recruitingTeam.customer?.paymentMethods.length,
        }
    })

export { ChangePartnershipTierModalProvider, useChangePartnershipTierModal }
